<template>
  <dashboard-block
    title="Откуда и как платят"
    :caption="caption"
    :loading="loading"
    :missing="!block"
    :min-height="346"
    skeleton="list-item-two-line@3"
  >
    <v-row v-if="block">
      <v-col
        v-for="group in groups"
        :key="group.title"
        cols="12"
        sm="6"
        md="12"
      >
        <div class="text-caption text--secondary mb-2">
          {{ group.title }}
        </div>

        <div
          v-if="group.problem"
          class="text-body-2 text--secondary"
        >
          {{ group.problem }}
        </div>

        <template v-else>
          <dashboard-bar-row
            v-for="row in group.rows"
            :key="row.key"
            :label="row.name"
            :value="row.value"
            :note="row.note"
            :fraction="row.fraction"
          ></dashboard-bar-row>
        </template>
      </v-col>
    </v-row>
  </dashboard-block>
</template>

<script>
import DashboardBlock from '@/views/dashboard/dashboard-block'
import DashboardBarRow from '@/views/dashboard/dashboard-bar-row'
import { toOrdersString, toPercentString, toPeriodString } from '@/helpers/dashboard'

export default {
  name: 'DashboardChannels',
  components: { DashboardBlock, DashboardBarRow },
  props: {
    block: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  computed: {
    caption() {
      const period = this.block ? toPeriodString(this.block.from, this.block.to) : ''

      return period ? `Доли заказов за ${period}` : 'Доли заказов'
    },
    groups() {
      return [
        this.group('Откуда заказывают', this.block.sources),
        this.group('Как платят', this.block.payments),
      ]
    },
  },
  methods: {
    group(title, rows) {
      if (!rows) return { title, problem: 'Этот список не прочитался.' }
      if (!rows.some(row => row.orders > 0)) return { title, problem: 'Заказов за это время не было.' }

      return {
        title,
        rows: rows.map(row => ({
          key: row.key,
          name: row.name,
          value: toPercentString(row.share),
          note: row.orders === null ? '' : toOrdersString(row.orders),
          fraction: row.share === null ? null : row.share / 100,
        })),
      }
    },
  },
}
</script>
